// 岗位职责查询
<template>
  <div class="response-history atb-flex atb-flex-column">
    <div class="atb-content-bg atb-flex atb-flex-column">
      <div class="search">
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
          <el-form-item class="flex-form-item" label="部门名称" prop="departmentNo">
            <el-popover placement="bottom-start" width="420" popper-class="popper-tree declare-dep" @hide="handledHide" trigger="click">
              <el-tree
                :props="defaultProps"
                :data="treeData"
                show-checkbox
                node-key="id"
                ref="tree"
                highlight-current
                :default-expanded-keys="expandedData"
                @check-change="handleCheckChange"
              >
              </el-tree>
              <el-input slot="reference" v-model="department" placeholder="请选择部门名称" clearable></el-input>
            </el-popover>
          </el-form-item>
          <el-form-item label="人员姓名">
            <selecter v-model="searchParam.wkName"></selecter>
          </el-form-item>
          <el-form-item label="年份">
            <el-date-picker v-model="searchParam.date" type="year" format="yyyy 年" value-format="yyyy-MM-dd" placeholder="选择年份"></el-date-picker>
          </el-form-item>
          <el-form-item label="数据权限" prop="authType">
            <el-select v-model="searchParam.authType" placeholder="">
              <el-option v-for="item in authTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList(1)">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="export" @click="exportTask">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class='table-content atb-flex atb-flex-column'>
        <vxe-table
          class='atb-table header-table edit-table'
          border='full'
          height='100%'
          auto-resize
          resizable
          :data="tableData"
          ref="historyTable"
          :edit-config="{trigger: 'manual', mode: 'row'}"
          :merge-cells="mergeCells"
          @cell-dblclick="dbClickGoDetail"
          @cell-click="expandRow"
        >
          <vxe-table-column type="checkbox" width="50" align="center"></vxe-table-column>
          <vxe-table-column field="rowNumber" width="50" title="NO."></vxe-table-column>
          <vxe-table-column field="wkNo" title="工号" width="100"></vxe-table-column>
          <vxe-table-column field="wkName" title="姓名" width="120">
            <template #default="{row}">
              <span class="table-link" @click.stop="toDetailList({row})">{{ row.wkName }}</span>
              <el-tooltip v-if="row.isTemporaryWkNo" class="temporary-tip" effect="dark" content="挂职" placement="top" :popper-options="{removeOnDestroy: true}">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </template>
          </vxe-table-column>
          <vxe-table-column field="year" title="年份" width="60"></vxe-table-column>
          <vxe-table-column field="department" title="部门" width="360" ></vxe-table-column>
          <vxe-table-column field="commitDate" title="提交时间" width="100">
            <template #edit="{ row }">
              <el-date-picker v-model="row.commitDate" type="date" value-format="yyyy/MM/dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{row.commitDate ? new Date(row.commitDate).toLocaleDateString() : ''}}</template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" width="120">
            <template #default="{ row }">
              <template v-if="row.status || row.status === 0">
                <el-tag v-if="row.status === 10" type="close" effect="dark">
                  {{ statusMap[row.status] || '' }}
                </el-tag>
                <el-tag v-else-if="row.status === -1" type="unstart" effect="dark">
                  {{ statusMap[row.status] || '' }}
                </el-tag>
                <el-tag v-else type="complete" effect="dark">
                  {{ statusMap[row.status] || '' }}
                </el-tag>
              </template>
            </template>
          </vxe-table-column>
          <vxe-table-column field="approveReason" title="审批意见" min-width="200">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.approveReason || '无' }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" class-name='operation' width="80">
            <template #default="scope">
              <el-tooltip class='item' effect='dark' content='编辑' placement="bottom" v-if="scope.row.isExist && scope.row.status != -1">
                <i class='icon-editor' @click.stop='goDetail({row: scope.row})'></i>
              </el-tooltip>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="page-con atb-flex atb-flex-justify-end">
        <vxe-pager
          background
          :current-page.sync="page.pageIndex"
          :page-size.sync="page.pageSize"
          :total="total"
          height="100%"
          @page-change="handlePageChange"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
        >
        </vxe-pager>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  components: {
    selecter: () => import('@/component/global/customerSelect'),
  },
  name: 'ResponseHistory',
  data() {
    return {
      searchParam: {
        date: new Date(),
        authType: 0,
        wkNo: '',
      },
      page: {
        pageIndex: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
      that: this,
      expandedData: [],
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      depList: [],
      department: '',
      departmentNo: '',

      authTypeList: [
        { label: '直属下级', value: 0 },
        { label: '全部下级', value: 1 },
        { label: '数据权限', value: 2 },
        { label: '全部', value: 3 },
      ],
      mergeCells: [],
      statusMap: {},

    };
  },
  computed: {},
  created() {
    this.getStatus();
  },
  mounted() {
    this.getDep();
  },
  activated() {
    this.getList();
  },
  methods: {
    getStatus() {
      return this.$ajax.get(this.$api.common.getDict, { ItemType: 'ResponseStatus' }).then((res) => {
        let rows = res.data.rows || [];
        this.statusMap = {};
        rows.forEach(item => {
          this.statusMap[item.itemValue] = item.itemDesc;
        })
      });
    },
    expandRow({ rowIndex }) {
      this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
      this.$refs.historyTable.updateData(this.tableData);
    },
    getList(page) {
      if (page) this.page.pageIndex = page;
      const queryWhere = _.cloneDeep(this.searchParam);
      const pageParam = { skipCount: (this.page.pageIndex - 1) * this.page.pageSize, maxResultCount: this.page.pageSize };
      let param = Object.assign({department: this.departmentNo}, queryWhere, pageParam);
      this.$ajax.post(this.$api.responsWork.history.list, param).then((res) => {
        const rows = res.data.rows || [];
        rows.forEach(val => {
          val.expandRowFlag = false;
        })
        this.handleTableData(rows);
        this.total = res.data.total;
      });
    },
    handleTableData(rows) {
      let tableData = [];
      let mergeCells = [];
      let rowIndex = 0;

      rows.forEach((item, index) => {
        let childRows = item.data || [];
        if (childRows.length === 0) {
          childRows = [item];
        }
        childRows.forEach(childItem => {
          tableData.push({
            ...childItem,
            isExist: item.data.length > 0,
            isTemporaryWkNo: item.isTemporaryWkNo,
            rowNumber: (this.page.pageIndex - 1) * this.page.pageSize + index + 1
          });
        })
        const length = childRows.length;
        mergeCells.push(
          ...[
            {row: rowIndex, col: 0, rowspan: length, colspan: 1},
            {row: rowIndex, col: 1, rowspan: length, colspan: 1},
            {row: rowIndex, col: 2, rowspan: length, colspan: 1},
            {row: rowIndex, col: 3, rowspan: length, colspan: 1},
            {row: rowIndex, col: 4, rowspan: length, colspan: 1},
          ]
        )
        rowIndex += childRows.length;

      });
      this.tableData = tableData;
      this.mergeCells = mergeCells;
    },
    async getDep() {
      await this.$ajax.get(this.$api.Identity.Categord.dep, {}).then((res) => {
        this.depList = res.data || [];
        this.depList.forEach((v) => {
          const objClone = {};
          (objClone.id = v.id), (objClone.code = v.code), (objClone.label = v.displayName);
          if (v.parentId === null) {
            this.expandedData.push(v.id);
            objClone.children = this.depList.filter((t) => t.parentId === v.id);
            this.generateMenu(objClone.children);
            this.treeData.push(objClone);
          }
        });
      });
    },
    generateMenu(chs) {
      chs.forEach((v) => {
        v.label = v.displayName;
        v.children = this.depList.filter((t) => t.parentId === v.id);
        this.generateMenu(v.children);
      });
    },
    handleCheckChange(){
      this.selectNode = this.getSimpleCheckedNodes(this.$refs.tree.store);
      let code = [] , deptNmae = [];
      this.selectNode.forEach(t => {
        code.push(t.code);
        deptNmae.push(t.label);
      });
      this.departmentNo = code.join(",");
      this.department = deptNmae.join(",");
    },
    getSimpleCheckedNodes(store) {
      const checkedNodes = [];
      const traverse = function(node) {
        const childNodes = node.root ? node.root.childNodes : node.childNodes;
        childNodes.forEach(child => {
          if (child.checked) {
            checkedNodes.push(child.data);
          }
          if (child.indeterminate) {
            traverse(child);
          }
        });
      };
      traverse(store)
      return checkedNodes;
    },
    getChildrenMenu(depData = []) {
      let depTree = [];
      depData.forEach((t) => {
        if (t.label.indexOf(this.department) != -1) {
          depTree.push(t);
        } else {
          if (t.children && t.children.length) {
            t.children = this.getChildrenMenu(t.children);
            if (t.children && t.children.length) {
              depTree.push(t);
            }
          }
        }
      });
      return (this.treeData = depTree);
    },
    handledHide() {
      this.$nextTick(() => {
        if (!this.$refs.tree.getCheckedKeys().length) {
          this.department = '';
        }
      });
    },
    handlePageChange({ currentPage }) {
      this.getList(currentPage);
    },
    exportTask() {
      const queryWhere = _.cloneDeep(this.searchParam);
      let select = this.$refs.historyTable.getCheckboxRecords();
      const res = select.map(val => val.wkNo).join(",");
      this.$ajax
        .get(this.$api.responsWork.history.exportTask, Object.assign(queryWhere, {department: this.departmentNo, exportWkNos: res,}))
        .then((res) => {
          if (res.code === 0) {
            this.$router.push({
              path: '/manage/export-task/index',
            });
          }
        })
        .catch(() => {});
    },
    toDetailList({row}) {
      this.$router.push({
        path: '/response/history/detail',
        query: {
          wkNo: row.wkNo,
          wkName: row.wkName,
          isTemporaryWkNo: row.isTemporaryWkNo ? '1' : '0',
        },
      });
    },
    // 双击跳转详情页，合并行不能双击跳转
    dbClickGoDetail({row, columnIndex}) {
      if (columnIndex < 4) return false;
      if (!row.isExist || row.status == -1) return false;
      this.goDetail({row});
    },
    goDetail({row}) {
      this.$router.push({
        path: '/response/personal/detail',
        query:{
          id: row.id,
          editStatus: 'approve',
          isTemporaryWkNo: row.isTemporaryWkNo ? '1' : '0',
        }
      });
    },
  },
  watch: {
    department: {
      handler(val) {
        if (!val) {
          this.departmentNo = '';
          this.$refs.tree && this.$refs.tree.setCheckedKeys([]);
        }
      },
      immediate: true,
    },
  },
};
</script>
<style scoped lang="scss">
.response-history {
  height: 100%;
  .search {
    .el-date-editor--daterange {
      width: 360px;
      border-radius: 10px;
    }
  }
  .atb-content-bg {
    margin-top: 0px;
    padding: 20px;
    flex: 1;
  }
  .temporary-tip {
    color: #777;
    margin-left: 4px;
    transform: translateY(1px);
  }
  ::v-deep .el-tag {
    padding: 0 8px;
    width: auto;
  }
  .plan_table {
    padding: 0 5px;
  }
  .el-link--danger {
    cursor: auto;
  }
  .el-button.is-disabled, .el-button.is-disabled:hover, .el-button.is-disabled:focus {
    background-color: #f2f2f2!important;
    border-color: #ebeef5!important;
    color: #c0c4cc;
  }
}
.footer {
  text-align: right;
  margin-top: 20px;
  .select-all-program {
    margin-right: 20px;
  }
}
.declare-dep {
  height: 350px;
  width: 350px;
  overflow: auto;
}
</style>
